__turbopack_context__.v({
  "component": "style-module-scss-module__HDKR_G__component",
  "exp-icon-middle": "style-module-scss-module__HDKR_G__exp-icon-middle",
  "exp-tag": "style-module-scss-module__HDKR_G__exp-tag",
  "exp-theme": "style-module-scss-module__HDKR_G__exp-theme",
  "icon-input": "style-module-scss-module__HDKR_G__icon-input",
  "icon-input-both": "style-module-scss-module__HDKR_G__icon-input-both",
  "icon-input-middle": "style-module-scss-module__HDKR_G__icon-input-middle",
  "icon-input-right": "style-module-scss-module__HDKR_G__icon-input-right",
  "icon-middle": "style-module-scss-module__HDKR_G__icon-middle",
  "icon-right": "style-module-scss-module__HDKR_G__icon-right",
  "padded": "style-module-scss-module__HDKR_G__padded",
  "tag": "style-module-scss-module__HDKR_G__tag",
});
